/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Chat_Tool_Detail_MessagesInputs */

const es_chat_tool_detail_messages = /** @type {(inputs: Chat_Tool_Detail_MessagesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} mensajes`)
};

const en_chat_tool_detail_messages = /** @type {(inputs: Chat_Tool_Detail_MessagesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} messages`)
};

/**
* | output |
* | --- |
* | "{count} messages" |
*
* @param {Chat_Tool_Detail_MessagesInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_tool_detail_messages = /** @type {((inputs: Chat_Tool_Detail_MessagesInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Detail_MessagesInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_tool_detail_messages(inputs)
	return en_chat_tool_detail_messages(inputs)
});
export { chat_tool_detail_messages as "chat.tool_detail.messages" }